/** biome-ignore-all lint/correctness/noUnusedImports: reason */
import React from "react";

import { ActivityProvider } from "../activity";
import { BatchesProvider } from "../batches";
import { BrandsProvider } from "../brands";
import { ClientsProvider } from "../clients";
import { CompaniesProvider } from "../companies";
import { CompanyProvider } from "../company";
import { FillsProvider } from "../fills";
import MapContextProvider from "../googleMap";
import { IntegrationsProvider } from "../integrations";
import { KegsProvider } from "../kegs";
import { LocationsProvider } from "../locations";
import { PartnersProvider } from "../partners";
import { ReportsProvider } from "../reports";
import { UsersProvider } from "../users";
import VolumeProvider from "../volume";
import VolumeByBrandProvider from "../volume/byBrand";

const DataProvider = ({ children }) => {
  return (
    <MapContextProvider>
      <IntegrationsProvider>
        <CompanyProvider>
          <CompaniesProvider>
            <KegsProvider>
              <ReportsProvider>
                <LocationsProvider>
                  <ClientsProvider>
                    <BrandsProvider>
                      <BatchesProvider>
                        <PartnersProvider>
                          <ActivityProvider>
                            <FillsProvider>
                              <VolumeByBrandProvider>
                                <VolumeProvider>
                                  <UsersProvider>{children}</UsersProvider>
                                </VolumeProvider>
                              </VolumeByBrandProvider>
                            </FillsProvider>
                          </ActivityProvider>
                        </PartnersProvider>
                      </BatchesProvider>
                    </BrandsProvider>
                  </ClientsProvider>
                </LocationsProvider>
              </ReportsProvider>
            </KegsProvider>
          </CompaniesProvider>
        </CompanyProvider>
      </IntegrationsProvider>
    </MapContextProvider>
  );
};

export default DataProvider;
